/**
 * Sep 24 — the confirmation step of THIS registration, on THIS session: where the
 * pay page sends the rep back. The session id lets a cold tab (a refresh, a new
 * window) reload the registration; a warm one refetches it.
 */
export const teamBudgetReturnPath = (
  reviewPath: string,
  sessionId: string
): string =>
  `${reviewPath}${
    reviewPath.includes('?') ? '&' : '?'
  }registration_session_id=${encodeURIComponent(sessionId)}`

/** The pay page for an invoice (`pay_path`), coming back to `returnTo` when done. */
export const payPathWithReturn = (payPath: string, returnTo: string): string =>
  `${payPath}${payPath.includes('?') ? '&' : '?'}returnTo=${encodeURIComponent(
    returnTo
  )}`
